/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Duplicate Lines — Dedupe Text Online | Toolverse`)
};

const es_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Líneas Duplicadas — Desduplicar Texto Online | Toolverse`)
};

const de_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelte Zeilen entfernen — Text online bereinigen | Toolverse`)
};

const nl_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijder Dubbele Regels — Dedupliceer Tekst Online | Toolverse`)
};

const fr_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les lignes en doublon — Dédupliquer le texte en ligne | Toolverse`)
};

const it_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi Righe Duplicate — Deduplicare Testo Online | Toolverse`)
};

const pt_br2_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover Linhas Duplicadas — Remova Texto Duplicado Online | Toolverse`)
};

const pt_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover Linhas Duplicadas — Remover Duplicatas de Texto Online | Toolverse`)
};

const ja_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複行削除 — テキストの重複をオンラインで削除 | Toolverse`)
};

const zh_rd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除重复行 — 在线文本去重工具 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_meta_title", locale)
	if (locale === "en") return en_rd_meta_title(inputs)
	if (locale === "es") return es_rd_meta_title(inputs)
	if (locale === "de") return de_rd_meta_title(inputs)
	if (locale === "nl") return nl_rd_meta_title(inputs)
	if (locale === "fr") return fr_rd_meta_title(inputs)
	if (locale === "it") return it_rd_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_rd_meta_title(inputs)
	if (locale === "pt") return pt_rd_meta_title(inputs)
	if (locale === "ja") return ja_rd_meta_title(inputs)
	return zh_rd_meta_title(inputs)
};